<template lang="pug">
  div

    v-layout.my-6(v-if="isFetching")
      v-row.fill-height.ma-0(align='center' justify='center')
        v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)

    .content-layout(v-else)
      v-card(outlined)
        v-layout.ma-0.py-6(v-if="bankList.length == 0")
          div.mx-auto.text-center
            v-img.mx-auto(:src="require('@/assets/images/icon_empty.png')" style="width:80px; height:80px" contain)
            p.caption {{ $t('no_banks_added') }}
        v-simple-table(v-else fixed-header)
          template(v-slot:default)
            thead
              tr
                th.text-left.s2.primary400--text(style="background-color: #f7f7f7") {{ $t('bank') }}
                th.text-left.s2.primary400--text(style="background-color: #f7f7f7" colspan="2") {{ $t('activate') }}
            tbody
              tr(v-for="(bank, index) in bankList" :key="bank.id")
                td.py-2.pr-0
                  div.s2.default--text {{ getBank(index).bank_name }}
                td.text-center.d-grid
                  y-switch.mt-3(v-model="getBank(index).enabled" @change="toggleActiveBank(bank)")
                td.py-2.pl-0.pr-2
                  div.d-flex
                    v-btn.mr-3(icon small @click="clickDeleteBank(bank)")
                      eva-icon(name ="trash-outline" :fill="$vuetify.theme.themes[$theme].danger")
                    v-btn(icon small @click="clickEditBank(bank)")
                      eva-icon(name ="edit-outline" :fill="$vuetify.theme.themes[$theme].default")
      v-layout.mt-4.mb-2
        v-btn.my-auto.ml-2.info500--text.button-Aa-small( depressed small color="white" height=20 @click="clickAddBank")
          v-icon.ml-n2(left size=14) mdi-plus
          div.ml-n2.mr-n1  {{ $t('add_bank') }}

    .modals
      update-cash-payment(v-if="showUpdateCashDialog" :open.sync="showUpdateCashDialog" :company="company" :bank="editingBank" @added="handleAddItem" @edited="handleEditItem")
      y-dialog(v-model='showDeleteBankDialog', max-width='320')
        v-card
          v-card-title.h6.basic800--text.px-4 {{ $t('delete_bank') }}
          v-card-text.p2.primary500--text.px-4
            div {{ $t('delete_bank_confirmation') }}
          v-card-actions
            v-spacer
            v-btn(color='white', text @click='showDeleteBankDialog = false')
              .button-Aa-small.primary400--text {{ $t('cancel') }}
            v-btn.mr-2(color='danger500' depressed height=32 @click='startDelete' :loading="isLoading" dark)
              .button-AA-small.basic100--text {{ $t('delete') }}

</template>

<script>
import { mapActions } from 'vuex'
import UpdateCashPayment from '@/components/dialogs/settings/UpdateCashPayment.vue'

export default {
  name: 'CashPaymentList',
  components: { UpdateCashPayment },
  props: ['company'],
  data: () => ({
    isFetching: true,
    isLoading: false,
    showUpdateCashDialog: false,
    showDeleteBankDialog: false,
    editingBank: null,
    bankList: [],
  }),
  mounted () {
    this.isFetching = true
    this.fetchBanks()
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    getBank (index) {
      return this.bankList[index]
    },
    clickDeleteBank(bank) {
      this.showDeleteBankDialog = true
      this.deleteBank = bank
    },
    fetchBanks () {
      this.$axios.get(`/directpay_creds/?company=${this.company.id}`)
        .then((response) => {
          this.bankList = response.data.results
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false
        })
    },
    clickAddBank () {
      
      this.editingBank = null
      this.showUpdateCashDialog = true
    },
    clickEditBank (bank) {
      this.editingBank = bank
      this.showUpdateCashDialog = true
    },
    startDelete() {
      this.isLoading = true
      this.axios.delete(`/directpay_creds/${this.deleteBank.id}/`)
        .then(() => {
          this.bankList = this.bankList.filter((x) => x !== this.deleteBank)
          this.showDeleteBankDialog = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    toggleActiveBank(bank) {
      let changeIndex = 0
      this.bankList.forEach((item, index) => {
        if (bank.id === item.id) {
          changeIndex = index
        }
      })
      var params = {
        company: this.company.id,
        enabled: bank.enabled
      }
      this.axios.put(`/directpay_creds/${bank.id}/`, params)
        .catch(() => {
          this.bankList[changeIndex].enabled = !bank.enabled
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
    },
    handleAddItem (item) {
      this.bankList.push(item)
    },
    handleEditItem (item) {
      let addToIndex = 0
      this.bankList.forEach((bank, index) => {
        if (bank.id === item.id) {
          addToIndex = index
        }
      })
      this.bankList = this.bankList.filter((x) => x.id !== item.id)
      this.bankList.splice(addToIndex, 0, item)
    }
  }
}
</script>

<style scoped>
</style>

<i18n>
{
  "en": {
    "no_banks_added": "No banks added yet",
    "delete_bank": "Delete bank",
    "delete_bank_confirmation": "Are you sure you want to delete this bank? This bank details will be deleted permanently."
  },
  "id": {
    "no_banks_added": "Belum ada bank akun yang ditambahkan",
    "delete_bank": "Hapus bank akun",
    "delete_bank_confirmation": "Anda yakin ingin menghapus bank ini? Detail bank ini akan dihapus secara permanen."
  }
}
</i18n>

